export default {"src":"/_next/static/media/keen_mobile_arrow.0a5026b2.svg","height":42,"width":42,"blurWidth":0,"blurHeight":0};